import React from 'react';
import './App.css';
import {BrowserRouter} from "react-router-dom";
import {Route} from "react-router";
import Dams from "./components/dams";
import Assessments from "./components/assessments";
import Assessment from "./screens/assessment";
import Login from "./components/login";
import Portfolios from "./components/portfolios";
import Dashboard from "./screens/dashboard";
import Admin from "./screens/admin";
import ProjectUsers from './screens/project_users';
import ProjectTemplateSettings from './screens/project_template_settings';
import ProjectSettings from './screens/project_settings';
import {ErrorSnackbarProvider} from "./components/errorsnackbarcontext";
import { TasksContext, TasksDispatchContext, TasksProvider } from './stateManagement/context';
import Prioritisation from './screens/prioritisation';



function App() {
  return (
      <div className="App">
        <ErrorSnackbarProvider>
        <TasksProvider>
        <BrowserRouter>
            <Route exact path='/' component={Portfolios}/>
            <Route exact path='/admin' component={Admin}/>
            <Route exact path='/dams/:id' component={Dams}/>
            <Route exact path='/admin/:id' component={ProjectSettings}/>
            <Route exact path='/admin/:id/users' component={ProjectUsers}/>
            <Route exact path='/admin/:id/templates' component={ProjectTemplateSettings}/>
            <Route exact path='/assessments/:id' component={Assessments}/>
            <Route exact path='/assessment/:id' component={Assessment}/>
            <Route exact path='/login' component={Login}/>
            <Route exact path='/dashboard/:id' component={Dashboard}/>
            <Route exact path='/prioritisation/:id' component={Prioritisation}/>
        </BrowserRouter>
        </TasksProvider>
        </ErrorSnackbarProvider>
      </div>
  );
}

export default App;
